import React, { useState } from 'react'
import Header from '../../Header'
import * as styled from '../../style/main.style'
import Navbar from '../../Navbar'
import Customize from '../../../../component/fileUp/customize'

// STORE




const CustomizeSetting: React.FC = () => {
    const handleSubmit = () => {
        console.log('hello')
    }


    return (
        <styled.ContainerHome>
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <styled.TopicHeader>
                        <main className='flex flex-col w-full'>
                            <section>
                                <Customize
                                    onClickUpload={handleSubmit}
                                />
                            </section>
                        </main>
                    </styled.TopicHeader>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default CustomizeSetting